import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1b7f14ee&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QPageSticky,QTable,QTr,QTd,QChip,QBtn,QTooltip,QDialog,QCard,QCardSection,QAvatar,QCardActions,QIcon,QColor,ClosePopup} from 'quasar'
component.options.components = Object.assign({QPage,QPageSticky,QTable,QTr,QTd,QChip,QBtn,QTooltip,QDialog,QCard,QCardSection,QAvatar,QCardActions,QIcon,QColor}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
